(() => {
  if (window.npwProductTermGuard) return;
  window.npwProductTermGuard = true;
  const allowed = new WeakSet();
  const pending = new WeakSet();
  let queue = Promise.resolve();
  document.addEventListener('submit', event => {
    const form = event.target;
    const field = form.querySelector('[data-npw-product-term]');
    if (!field) return;
    if (allowed.has(form)) { allowed.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    const select = field.querySelector('[data-npw-term-select]');
    if (!select.value) { select.reportValidity(); select.focus(); return; }
    if (pending.has(form)) return;
    pending.add(form);
    const chosen = select.value;
    const status = field.querySelector('[data-npw-term-status]');
    const button = event.submitter || form.querySelector('[name="add"]');
    status.textContent = field.dataset.saving;
    status.hidden = false;
    select.disabled = true;
    if (button) button.disabled = true;
    queue = queue.catch(() => {}).then(async () => {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Verkaufstermin: chosen } })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (cart.attributes?.Verkaufstermin !== chosen) throw new Error('Term not confirmed');
      select.disabled = false;
      if (button) button.disabled = false;
      status.hidden = true;
      allowed.add(form);
      form.requestSubmit(button);
    }).catch(() => {
      status.textContent = field.dataset.error;
      status.hidden = false;
      if (button) button.disabled = false;
    }).finally(() => { select.disabled = false; pending.delete(form); });
  }, true);
})();

